<template>
  <b-modal id="updateCyclicTaskModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmcyclictask.updateCyclicTaskModalHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="cyclicTask">
      <b-col>
        <Update :cyclicTaskId="cyclicTask['@id']"></Update>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Update from '../Update.vue'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'UpdateCyclicTaskModal',
  components: {
    Update
  },
  computed: {
    show () {
      return this.$store.state.modals.excmcyclictask.update.show
    },
    cyclicTaskObject () {
      return this.$store.state.modals.excmcyclictask.update.cyclicTask
    },
    close () {
      return this.$store.state.modals.excmcyclictask.update.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'cyclicTaskObject': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      cyclicTask: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.cyclicTaskObject) {
        this.cyclicTask = Object.assign({}, this.cyclicTaskObject)
        this.$store.state.modals.excmcyclictask.update.show = 0
        this.$store.state.modals.excmcyclictask.update.cyclicTask = null
        this.$bvModal.show('updateCyclicTaskModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmcyclictask.update.close = 0
        this.$bvModal.hide('updateCyclicTaskModal')
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
